export default {"src":"/_next/static/media/chevron.00d27092.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};